import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// import NorowsData from '../../../pages/General/NorowsData'

import { fetchNotificationEvents, fetchchannelconfig, updatechannelconfig, updateNotificationEvents, resetConfigureState } from './emailSlice';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    height: '100%'
}));

// Standard corporate outliner dictionary configuring premium input layouts
const enterpriseInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        '& fieldset': { borderColor: '#E2E8F0' },
        '&:hover fieldset': { borderColor: '#CBD5E1' },
        '&.Mui-focused fieldset': { 
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-root': {
        color: '#64748B',
        fontWeight: 500,
        '&.Mui-focused': { color: '#1976d2' }
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const EmailIntegration = ({ storeName, platformName, storeParam, storeId }) => {
    const dispatch = useDispatch();
    const email = useSelector(state => state.email && state.email.event);
    const notificationconfig = useSelector(state => state.email && state.email.notificationconfig);
    const channelconfig = useSelector(state => state.email && state.email.channelconfig);
    const profile = useSelector(state => state.auth);
    const [alert, setAlert] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [choosenSMTPId, setChoosenSMTPId] = useState('default');
    const handleClose = () => {
        dispatch(resetConfigureState())
        setSnackOpen(false);
        setAlert(false);
    };


    const initialValues = {
        id: '',
        from_name: '',
        reply_to_email: '',
        smtp_method: 'default',
        notification_type: 'EMAIL',
        from_email: "",
        host: "",
        username: "",
        password: "",
        port: '',
        encryption: '',
        is_enabled: false
    }
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});

    const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('from_name' in fieldValues)
            temp.from_name = fieldValues.from_name ? "" : "This field is required."
        if ('reply_to_email' in fieldValues)
            temp.reply_to_email = fieldValues.reply_to_email ? "" : "This field is required."

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x == "")
    }

    const onChangeSMTP = (items) => {
        setChoosenSMTPId(items)
        setValues({
            ...values,
            smtp_method: items
        })
    }

    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: e.target.checked,
        });
        validator({ [name]: value })
    };
    const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            let data = ''
            if (values.smtp_method === 'default') {
                data = { "id": values.id, "from_name": values.from_name, "notification_type": values.notification_type, "reply_to_email": values.reply_to_email, "smtp_method": values.smtp_method, "is_enabled": values.is_enabled }
            } else {
                data = values
            }
            dispatch(updatechannelconfig(profile.profile.id,data));
        }
    }

    const onChangeEventConfigure = (e, values) => {
        let data = { 'event_key': values.event_key, 'id': values._id, 'is_enabled': String(e), 'notification_type': values.notification_type }
        dispatch(updateNotificationEvents(profile.profile.id,data));
    }
    const columns = [
        { field: 'event_name', headerName: 'Event Type', flex: 1, resizable: false, renderCell: (params) => <Typography variant="body2" sx={{ fontWeight: 600, color: '#1E293B' }}>{params.row.event_name}</Typography> },
        // { field: 'notification_type', headerName: 'Email', flex: 1 },
        {
            field: 'notification_type',
            headerName: 'Email Status',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Switch
                        defaultChecked={params.row.is_enabled}
                        name="is_update_shipment"
                        color="primary"
                        size="small"
                        onChange={(e) => {
                            onChangeEventConfigure(e.target.checked, params.row)
                        }
                        }
                    />
                )
            }
        },
        {
            field: 'Template',
            headerName: 'Template Actions',
            resizable: false,
            renderCell: (params) => {
                return (
                    <Button
                        component={Link}
                        to={`/notification/template/${params.row.event_key}/${params.row.notification_type}/${params.row.is_enabled}/${params.row._id}`}
                        variant="outlined"
                        size="small"
                        startIcon={<EditIcon sx={{ fontSize: '14px !important' }} />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '12.5px',
                            borderColor: '#E2E8F0',
                            color: '#1976d2',
                            backgroundColor: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#F0F9FF',
                                borderColor: '#bae6fd'
                            }
                        }}
                    >
                        Edit
                    </Button>
                )
            },
            flex: 1
        }
    ]
    useEffect(() => {
        if (channelconfig && channelconfig.data && channelconfig.data.length !== 0 && channelconfig.loading === false) {
            channelconfig && channelconfig.data && channelconfig.data.map((item) => {
                if (item.notification_type === 'EMAIL') {
                    setValues({
                        ...values,
                        id: item._id,
                        from_name: item.from_name,
                        reply_to_email: item.reply_to_email,
                        from_email: item.from_email,
                        host: item.host,
                        username: item.username,
                        password: item.password,
                        port: item.port,
                        encryption: item.encryption,
                        is_enabled: item.is_enabled
                    })
                    setChoosenSMTPId(item.smtp_method)
                }
            })

        }
    }, [channelconfig && channelconfig.data])

    useEffect(() => {
        dispatch(fetchNotificationEvents());
        dispatch(fetchchannelconfig());
    }, [dispatch])
    useEffect(() => {
        if (notificationconfig && notificationconfig.notification && notificationconfig.notification.showMessage) {
            setAlert(true)
            setSnackOpen(true)
        }

    }, [notificationconfig])
    return (
        <>
            {alert &&
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert
                        variant="filled"
                        severity={notificationconfig && notificationconfig.notification && notificationconfig.notification.messageType === "success" ? "success" : "error"}
                        sx={{ 
                            justifyContent: 'center', 
                            margin: "10px 0",
                            borderRadius: '12px',
                            fontWeight: 600,
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <span > {notificationconfig && notificationconfig.notification && notificationconfig.notification.messageContent}</span>
                    </Alert>
                </Snackbar>
            }
            {(email && email.loading === true) && (channelconfig && channelconfig.loading === true) && <>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '320px' }}>
                    <CircularProgress size={36} thickness={4.5} sx={{ color: '#1976d2' }} />
                </Box>
                </>
            } 
            {(email && email.loading === false) && (channelconfig && channelconfig.loading === false) && <>

            <Grid container spacing={0} sx={{ mb: 4 }}>
                <Grid item xs={12}>
                    <Card 
                        sx={{ 
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }} 
                        className="sc--cardhead--details"
                    >
                        <Box style={{ width: '100%', background: '#fff' }}>
                            <CardHeader 
                                title={
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                        SMTP Server Settings
                                    </Typography>
                                } 
                                sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                            />
                            <Divider sx={{ borderColor: '#E2E8F0' }} />
                            
                            <Box sx={{ p: 4 }}>
                                <Box sx={{ width: '100%', maxWidth: '640px', mx: 'auto' }}>
                                    <Stack spacing={3}>
                                        <Grid container spacing={0.5} className="sc--form--center">
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="From Name"
                                                    name="from_name"
                                                    size="small"
                                                    value={values.from_name}
                                                    onChange={onInputChange}
                                                    error={!!errors.from_name}
                                                    helperText={errors.from_name}
                                                    variant="outlined"
                                                    sx={enterpriseInputStyles}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Reply to email"
                                                    name="reply_to_email"
                                                    size="small"
                                                    value={values.reply_to_email}
                                                    onChange={onInputChange}
                                                    error={!!errors.reply_to_email}
                                                    helperText={errors.reply_to_email}
                                                    variant="outlined"
                                                    sx={enterpriseInputStyles}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Box className="sc--form--center">
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <InputLabel id="smtp-method-select-label" sx={enterpriseInputStyles['& .MuiInputLabel-root']}>SMTP Method Gateway</InputLabel>
                                                <Select
                                                    labelId="smtp-method-select-label"
                                                    id="demo-simple-select-standard"
                                                    name="smtp_method"
                                                    value={choosenSMTPId}
                                                    onChange={(e) => {
                                                        onChangeSMTP(e.target.value)
                                                    }}
                                                    label="SMTP Method Gateway"
                                                    sx={enterpriseInputStyles['& .MuiOutlinedInput-root']}
                                                >
                                                    <MenuItem value={'default'} sx={{ fontSize: '13.5px', py: 1 }}>Use ShippingChimp SMTP</MenuItem>
                                                    <MenuItem value={'custom'} sx={{ fontSize: '13.5px', py: 1 }}>Use Custom SMTP</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>

                                        {choosenSMTPId === 'custom' &&
                                            <Stack spacing={3} sx={{ p: 3, backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '12px' }}>
                                                <Grid container spacing={0.5} className="sc--form--center">
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="From Email"
                                                            name="from_email"
                                                            size="small"
                                                            value={values.from_email}
                                                            onChange={onInputChange}
                                                            error={!!errors.from_email}
                                                            helperText={errors.from_email}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="SMTP Host"
                                                            name="host"
                                                            size="small"
                                                            value={values.host}
                                                            onChange={onInputChange}
                                                            error={!!errors.host}
                                                            helperText={errors.host}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0.5} className="sc--form--center">
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="SMTP Username"
                                                            name="username"
                                                            size="small"
                                                            value={values.username}
                                                            onChange={onInputChange}
                                                            error={!!errors.username}
                                                            helperText={errors.username}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="SMTP Password"
                                                            name="password"
                                                            type="password"
                                                            size="small"
                                                            value={values.password}
                                                            onChange={onInputChange}
                                                            error={!!errors.password}
                                                            helperText={errors.password}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0.5} className="sc--form--center">
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="SMTP Port"
                                                            name="port"
                                                            size="small"
                                                            value={values.port}
                                                            onChange={onInputChange}
                                                            error={!!errors.port}
                                                            helperText={errors.port}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label="SMTP Encryption"
                                                            name="encryption"
                                                            size="small"
                                                            value={values.encryption}
                                                            onChange={onInputChange}
                                                            error={!!errors.encryption}
                                                            helperText={errors.encryption}
                                                            variant="outlined"
                                                            sx={enterpriseInputStyles}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Stack>
                                        }

                                        <Box sx={{ p: 2, backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '10px' }}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Switch
                                                        defaultChecked={channelconfig && channelconfig.data && channelconfig.data[0] && channelconfig.data[0].is_enabled ? channelconfig && channelconfig.data && channelconfig.data[0] && channelconfig.data[0].is_enabled : values.is_enabled}
                                                        name="is_enabled"
                                                        color="primary"
                                                        size="small"
                                                        onChange={handleChange}
                                                    />
                                                    }
                                                    label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155' }}>Active Channel Integration</Typography>}
                                                />
                                            </FormGroup>
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #F1F5F9', pt: 2.5 }} className="sc--form--center">
                                            <Button 
                                                variant="contained" 
                                                onClick={handleSubmit}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    fontSize: '13.5px',
                                                    height: '38px',
                                                    px: 4.5,
                                                    boxShadow: 'none',
                                                    backgroundColor: '#1976d2',
                                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                                }}
                                            >
                                                Save Settings
                                            </Button>
                                        </Box>
                                    </Stack>
                                </Box>
                            </Box>
                        </Box>
                    </Card>
                </Grid>
            </Grid>

            {/* Notification Configuration Records Grid Dashboard Module */}
            <Card 
                sx={{ 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }} 
                className="sc--cardhead--details"
            >
                <Box style={{ width: '100%', background: '#fff' }}>
                    <CardHeader 
                        title={
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                Configure Notifications
                            </Typography>
                        } 
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF', borderBottom: '1px solid #E2E8F0' }}
                    />
                    <Box sx={{ maxWidth: '100%' }}>
                        <DataGrid
                            getRowId={(row) => row._id}
                            disableRowSelectionOnClick
                            rows={email && email.data || []}
                            columns={columns}
                            autoHeight
                            hideFooter
                            loading={notificationconfig && notificationconfig.loading}
                            sx={{
                                border: 'none',
                                backgroundColor: '#FFFFFF',
                                '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC' },
                                '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', borderBottom: '1px solid #E2E8F0', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiDataGrid-row': { borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '14px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                            }}
                            slots={{
                                loadingOverlay: LinearProgress,
                            }}
                        />
                    </Box>
                </Box>
            </Card>
            </>
            }
        </>

    )
}

export default EmailIntegration;